import React from 'react';
import { Box } from '@mui/material';

import { ArcBoxProps } from './types';

const ArcBox: React.FC<ArcBoxProps> = (props) => {
  return <Box {...props} />;
};

export default ArcBox;